import * as React from 'react';

/** MUI Components */
import { Box, Typography, Button } from '@mui/material';

/** Internal Components */
import Copyright from '../components/CopyRight';
import { PAGE_STYLES } from '../theme/PageStyles';

/**
 * PageLayout component is a wrapper component that provides a consistent layout for all pages.
 * It includes a background image, title, description, button, and children components.
 * @param {Object} props - The component props.
 * @param {string} props.backgroundImage - The background image URL.
 * @param {string} props.title - The title of the page.
 * @param {string | string[]} props.description - The description of the page.
 * @param {string} props.buttonText - The text of the button.
 * @param {Function} props.onButtonClick - The function to be called when the button is clicked.
 * @param {boolean} props.isMediumScreen - Whether the screen is medium-sized.
 * @param {React.ReactNode} props.children - The children components to be rendered inside the page.
 */
export default function PageLayout({
    backgroundImage,
    title,
    description,
    buttonText,
    onButtonClick,
    isMediumScreen,
    children,
}) {
    return (
        <Box
            sx={{
                ...PAGE_STYLES.container,
                backgroundImage: `url(${backgroundImage})`,
            }}
        >
            <Box sx={PAGE_STYLES.contentBox(isMediumScreen)}>
                <Typography sx={PAGE_STYLES.title}>{title}</Typography>

                {Array.isArray(description) ? (
                    description.map((text, index) => (
                        <Typography key={index} sx={PAGE_STYLES.description}>
                            {text}
                        </Typography>
                    ))
                ) : (
                    <Typography sx={PAGE_STYLES.description}>{description}</Typography>
                )}

                {children}

                <Button onClick={onButtonClick} sx={PAGE_STYLES.button(isMediumScreen)}>
                    {buttonText}
                </Button>
            </Box>
            <Copyright />
        </Box>
    );
}
